module.exports = __webpack_public_path__ + "static/media/0_2019_04_27-2.fb20d73c.jpg";